import React from 'react'
import style from "./footer.module.css"
export const Footer = () => {
  return (
    <div className={style.footer}>
        <div>
           <div className={style.gridBox}>
              <div>
                <h1>Categories</h1>
                <p>Graphics & Design</p>
                <p>Digital Marketing</p>
                <p>Writing & Translation</p>
                <p>Video & Animation</p>
                <p>Music & Audio</p>
                <p>Programming & Tech</p>
                <p>Data</p>
                <p>Business</p>
                <p>Lifestyle</p>
                <p>Sitemap</p>
              </div>

              <div>
              <h1>About</h1>
              <p>Careers</p>
              <p>Press & News</p>
              <p>Partnerships</p>
              <p>Privacy Policy</p>
              <p>Terms of Service</p>
              <p>Intellectual Property Claims</p>
              <p>Investor Relations</p>
             
            </div>

            <div>
            <h1>Support</h1>
            <p>Help & Support</p>
            <p>Trust & Safety</p>
            <p>Selling on Trouper</p>
            <p>Buying on Trouper</p>
            </div>

            <div>
            <h1>Community</h1>
            <p>Events</p>
            <p>Blog</p>
            <p>Forum</p>
            <p>Community Standards</p>
            <p>Podcast</p>
            <p>Influencers</p>
            <p>Affiliates</p>
            <p>Invite a Friend</p>
            <p>Become a Seller</p>
            </div>

            <div>
            <h1>More From Trouper</h1>
            <p>Trouper Business</p>
            <p>Trouper Pro</p>
            <p>Trouper Studios</p>
            <p>Trouper Logo Maker</p>
            <p>Trouper Guides</p>
            <p>Get Inspired</p>
            <p>Trouper Select</p>
            <p>ClearVoice</p>
            <p>Trouper Workspace</p>
            <p>Learn</p>
            <p>Working Not Working</p>
            </div>

           </div>
           <ht />
           <div className={style.flexBox}>
               <div>
                  <img src="https://miro.medium.com/max/608/1*83ea0-gKieSinthdD9vjFg.jpeg" />
               </div>

               <div>
                 <img src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRH-_2lffJdy0UiavR-_TELiXDn5y30OjWMOg&usqp=CAU" />
                 <img src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTbkJf24KoeCDRRB5D3Y3rPKADvwkmP98eD2w&usqp=CAU" />
                 <img src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQ7HIfMu1JrdU5sHrLrj-zT7AOwTDuL1XFQFA&usqp=CAU" />
                 <img src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcT5DrTa1NZLEG39vbLMwWXJ-ecJgy8f7Scadg&usqp=CAU" />
                 <img src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRg4iwIKO7vNMJXXVlEa33yjE-UGchRJx1L-g&usqp=CAU" />
               </div>
           </div>
        </div>
    </div>
  )
}
